import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c('h1',{staticClass:"text-center"},[_vm._v("(404) Page NotFound")])])}
var staticRenderFns = []

export { render, staticRenderFns }